<!--
 * @Description:
 * @Author: PF
 * @Date: 2023-07-17 15:23:51
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">应急预案</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
      <el-container>
        <el-header>
          <el-tabs v-model="dataGrid.parms.sfd" @tab-change="bindTable()">
            <el-tab-pane label="全部" name=""></el-tab-pane>
            <el-tab-pane label="未读" :name="false"></el-tab-pane>
            <el-tab-pane label="已读" :name="true"></el-tab-pane>
          </el-tabs>
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
            <el-form-item>
              <el-select placeholder="预案类别" v-model="dataGrid.parms.yjyalbid" clearable filterable @change="bindTable()">
                <el-option v-for="(item, index) in yjyalbData" :key="index" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker placeholder="发布日期" v-model="dataGrid.parms.yjyafbsj" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" clearable @change="bindTable()"/>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="签发人" v-model="dataGrid.parms.yjyaqfrmc" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="发布范围" v-model="dataGrid.parms.yjyafbfwid" clearable filterable @change="bindTable()">
                <el-option v-for="(item, index) in yjyafbfwData" :key="index" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="预案名称" v-model="dataGrid.parms.yjyabt" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <!-- 搜索区域 END -->
        </el-header>
        <el-main>
          <el-row :gutter="20" class="wp100">
            <el-col :span="8" class="mb20" v-for="(item, index) in dataGrid.data" :key="index" @dblclick="openDetail=true; tcRow={ id: item.id, zt: 1 }">
              <el-card shadow="hover" class="pointer" >
                <template #header>
                  <div class="card-header">
                    <span style="font-size: 16px;font-weight: bold;">{{item.yjyabt}}</span>
                  </div>
                </template>
                <ul>
                  <li style="font-size: 14px;">预案名称：{{item.yjyabt}}</li>
                  <li style="font-size: 14px;">发布日期：{{item.yjyafbsj}}</li>
                  <li style="font-size: 14px;">发布范围：{{item.yjyafbfwmc}}</li>
                  <li style="font-size: 14px;">签发人：{{item.yjyaqfrmc}}</li>
                  <li style="font-size: 14px;">我的责任：
                    <span v-for="(val, ind) in item.wdzr" :key="ind">
                      <span v-if="ind > 0">、</span>
                      {{val.yjyatlbt}}
                    </span>
                  </li>
                </ul>
              </el-card>
            </el-col>
          </el-row>
        </el-main>
        <el-footer>
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </el-footer>
      </el-container>
    </div>
    </el-dialog>
  </div>
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="tcRow" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { loadList, homeCloseWindow } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import detail from '@/pages/pinganxiaoyuan/yingjiyuan/yingjiyuan/detail.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'yjyafbsj', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/pinganxiaoyuan/pinganxiaoyuanyingjiyuan/geren/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 弹窗
const tcRow = ref({})
const openDetail = ref(false)
const openList = ref(false)

watch(
  () => props.open,
  () => {
    if (props.open === 'yingjiyuan') {
      openList.value = true
      dataGrid.value.parms.sfd = false
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
.el-card__body {
  padding-bottom: 10px;
}
</style>
